import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createBrand,
  getBrand,
  getBrands,
  editBrand,
  deleteBrand,
} from "api/brandApi"

export const BRANDS_QUERY_KEY = "brands"

export const useBrands = (params = {}) => {
  return useQuery({
    queryKey: [BRANDS_QUERY_KEY, params], // include params in the query key for caching
    queryFn: () => getBrands(params),
    keepPreviousData: true, // optional, useful for pagination or filtering
  })
}

export const useBrand = id => {
  return useQuery({
    queryKey: [BRANDS_QUERY_KEY, id], // unique cache key
    queryFn: () => getBrand(id),
    enabled: !!id, // only run if id is provided
  })
}

export const useCreateBrand = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createBrand,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRANDS_QUERY_KEY]) // refresh brands list
      }
    },
  })
}

export const useEditBrand = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editBrand,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRANDS_QUERY_KEY]) // refresh brands list
      }
    },
  })
}

export const useDeleteBrand = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteBrand,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRANDS_QUERY_KEY]) // refresh brands list
      }
    },
  })
}
